var map = {
	"./cannon/angle_0.jpg": "375a",
	"./cannon/angle_105.jpg": "276a",
	"./cannon/angle_120.jpg": "0b43",
	"./cannon/angle_135.jpg": "facb",
	"./cannon/angle_15.jpg": "1751",
	"./cannon/angle_150.jpg": "990a",
	"./cannon/angle_165.jpg": "63c6",
	"./cannon/angle_180.jpg": "b396",
	"./cannon/angle_195.jpg": "bb22",
	"./cannon/angle_210.jpg": "383e",
	"./cannon/angle_225.jpg": "49b2",
	"./cannon/angle_240.jpg": "f0e4",
	"./cannon/angle_255.jpg": "7442",
	"./cannon/angle_270.jpg": "313f",
	"./cannon/angle_285.jpg": "9735",
	"./cannon/angle_30.jpg": "2705",
	"./cannon/angle_300.jpg": "0c67",
	"./cannon/angle_315.jpg": "3181",
	"./cannon/angle_330.jpg": "20bf",
	"./cannon/angle_345.jpg": "c052",
	"./cannon/angle_45.jpg": "e7a5",
	"./cannon/angle_60.jpg": "bef5",
	"./cannon/angle_75.jpg": "6b01",
	"./cannon/angle_90.jpg": "48a1",
	"./fiume/angle_0.jpg": "334b",
	"./fiume/angle_105.jpg": "c736",
	"./fiume/angle_120.jpg": "e324",
	"./fiume/angle_135.jpg": "0bdb",
	"./fiume/angle_15.jpg": "08dd",
	"./fiume/angle_150.jpg": "bc6a",
	"./fiume/angle_165.jpg": "f361",
	"./fiume/angle_180.jpg": "d8d4",
	"./fiume/angle_195.jpg": "9c1d",
	"./fiume/angle_210.jpg": "ec43",
	"./fiume/angle_225.jpg": "ce05",
	"./fiume/angle_240.jpg": "67bc",
	"./fiume/angle_255.jpg": "4008",
	"./fiume/angle_270.jpg": "41cf",
	"./fiume/angle_285.jpg": "bbad",
	"./fiume/angle_30.jpg": "514d",
	"./fiume/angle_300.jpg": "0a89",
	"./fiume/angle_315.jpg": "baa5",
	"./fiume/angle_330.jpg": "1e4c",
	"./fiume/angle_345.jpg": "a54e",
	"./fiume/angle_45.jpg": "63aa",
	"./fiume/angle_60.jpg": "74e5",
	"./fiume/angle_75.jpg": "5601",
	"./fiume/angle_90.jpg": "aca3",
	"./industrial/angle_0.jpg": "d244",
	"./industrial/angle_105.jpg": "4e02",
	"./industrial/angle_120.jpg": "a67b",
	"./industrial/angle_135.jpg": "2539",
	"./industrial/angle_15.jpg": "0c6b",
	"./industrial/angle_150.jpg": "66f4",
	"./industrial/angle_165.jpg": "bbcc",
	"./industrial/angle_180.jpg": "c23b",
	"./industrial/angle_195.jpg": "e9f8",
	"./industrial/angle_210.jpg": "3986",
	"./industrial/angle_225.jpg": "18a2",
	"./industrial/angle_240.jpg": "239d",
	"./industrial/angle_255.jpg": "9303",
	"./industrial/angle_270.jpg": "61d9",
	"./industrial/angle_285.jpg": "1d15",
	"./industrial/angle_30.jpg": "3022",
	"./industrial/angle_300.jpg": "d2eb",
	"./industrial/angle_315.jpg": "49f3",
	"./industrial/angle_330.jpg": "6ea0",
	"./industrial/angle_345.jpg": "2be4",
	"./industrial/angle_45.jpg": "3c3c",
	"./industrial/angle_60.jpg": "c4b2",
	"./industrial/angle_75.jpg": "68c6",
	"./industrial/angle_90.jpg": "c5eb",
	"./playazo/angle_0.jpg": "64de",
	"./playazo/angle_105.jpg": "b578",
	"./playazo/angle_120.jpg": "8943",
	"./playazo/angle_135.jpg": "c113",
	"./playazo/angle_15.jpg": "f1b7",
	"./playazo/angle_150.jpg": "85cf",
	"./playazo/angle_165.jpg": "8a78",
	"./playazo/angle_180.jpg": "60e1",
	"./playazo/angle_195.jpg": "9894",
	"./playazo/angle_210.jpg": "fbad",
	"./playazo/angle_225.jpg": "b87b",
	"./playazo/angle_240.jpg": "b05f",
	"./playazo/angle_255.jpg": "2dd7",
	"./playazo/angle_270.jpg": "582a",
	"./playazo/angle_285.jpg": "768c",
	"./playazo/angle_30.jpg": "857a",
	"./playazo/angle_300.jpg": "9e1b",
	"./playazo/angle_315.jpg": "8c3c",
	"./playazo/angle_330.jpg": "8b21",
	"./playazo/angle_345.jpg": "77d3",
	"./playazo/angle_45.jpg": "5467",
	"./playazo/angle_60.jpg": "1fd6",
	"./playazo/angle_75.jpg": "c588",
	"./playazo/angle_90.jpg": "37bf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b021";